<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For Madeleine L’Engle</i></span></p>
<p class="ded1"><span><i>1830–1917</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?9733e294